import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api, { analyticsApi, localapi, vnayaAnalyticsApi } from '../../Api/api';

export const generateShades = (count) => {
    return Array.from({ length: count }, (_, i) => {
        const lightness = 40 + (i * (40 / count));
        return `hsl(230, 60%, ${lightness}%)`;
    });
};
export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
};
/* =======================
   ASYNC API CALL
======================= */
export const getAnalytics = createAsyncThunk(
  'analytics/getAnalytics',
  async ({params}, { rejectWithValue }) => {
    let api=params?.app_id?.includes('vnaya')?vnayaAnalyticsApi:analyticsApi;
    try {
      const {data}= await api.get('/dashboard', {
        params,
      });
      console.log(data);
      
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getDimensions = createAsyncThunk(
  'analytics/getDimensions',
  async ({params}, { rejectWithValue }) => {
    let api=params?.app_id?.includes('vnaya')?vnayaAnalyticsApi:analyticsApi;
    try {
      const {data}= await api.get('/dimension', {
        params,
      });
      console.log(data);
      
      return {data,params};
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getRatingReviews = createAsyncThunk(
  'analytics/getRatingReviews',
  async ({params}, { rejectWithValue }) => {
    let api=params?.app_id?.includes('vnaya')?vnayaAnalyticsApi:analyticsApi;
    try {
      const {data}= await api.get('/reviews', {
        params,
      });
      console.log(data);
      
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
/* =======================
   INITIAL STATE
======================= */
const initialState = {
  data:[],
  loading: false,
  error: null,
  territory:null,
  device:null,
  source:null,
  rating:null
};

/* =======================
   SLICE
======================= */
const analytics = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAnalytics.fulfilled, (state, action) => {
        state.data = action.payload;
      })
      .addCase(getRatingReviews.fulfilled, (state, action) => {
        state.rating = action.payload;
      })
      .addCase(getDimensions.fulfilled, (state, action) => {
        const {data,params}=action.payload;
        state[params?.dimension]=data;
      })
      .addMatcher(
        (action) => action.type.startsWith('analytics/') && action.type.endsWith('/rejected'),
        (state, action) => {
          state.error = action.payload || 'An error occurred.';
        }
      );

  },
});

export default analytics.reducer;
